import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnderwritingComponent } from './underwriting/underwriting.component';
import { PolicyPurchaseDetailsComponent } from './policy-purchase-details/policy-purchase-details.component';
import { MyPolicyComponent } from './my-policy/my-policy.component';
import { PolicyInfoComponent } from './policy-info/policy-info.component';
import { PaymentFormComponent } from './payment-form/payment-form.component';
import { PaymentInfoComponent } from './payment-info/payment-info.component';

const routes: Routes = [
  { path: '', redirectTo: 'get-quote', pathMatch: 'full' },
  { path: 'underwriting/:quotationId/:quotesId', component: UnderwritingComponent },
  { path: 'policy-purchase-details', component: PolicyPurchaseDetailsComponent },
  { path: 'my-policy', component: MyPolicyComponent },
  { path: 'payment-form/:quotationId/:quotesId', component: PaymentFormComponent },
  { path: 'payment-info/:quotationId', component: PaymentInfoComponent },
  { path: 'policy-info/:quotationId/:quotesId', component: PolicyInfoComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PolicyRoutingModule { }
